<template>
    <v-app>
        <v-snackbar v-model="alert.show" :color="alert.color" top>
            {{alert.message}}
            <template v-slot:action="{ attrs }">
                <v-icon small dark v-bind="attrs" @click="alert.show = false">close</v-icon>
            </template>
        </v-snackbar>
        <router-view></router-view>
        <v-footer dense dark >
            <Footer />
        </v-footer>
    </v-app>
</template>

<script>
import { mapState } from "vuex";
import Footer from "@/components/Footer";

export default {
  name: "app",
  components: { Footer },
  computed: {
    ...mapState({
      alert: state => state.alert.alert
    })
  },
  data() {
    return {};
  }
};
</script>